import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
	selector: 'vl-select-custom',
	templateUrl: './vl-select-custom.component.html',
	styleUrls: ['./vl-select-custom.component.scss'],
})
export class VlSelectCustomComponent implements AfterViewInit, OnChanges {
	@Input('config') config: { type?: 'text' | 'icon'; isMulti?: boolean; options: Array<any> } = {
		type: 'text',
		isMulti: false,
		options: [],
	};
	@Input('value') value: string | Array<string> = '';
	@Input('placeholder') placeholder: string = '';
	@Output('changeSelection') changeSelection: EventEmitter<string | boolean | number | Array<string | boolean | number>> = new EventEmitter<
		string | boolean | number | Array<string | boolean | number>
	>();
	@Output('onBlur') onBlur: EventEmitter<any> = new EventEmitter<any>();
	public classMode: string = 'vlTk__control--select';
	public openDrawer: boolean = false;
	public labels: { [value: string]: string | boolean | number } = {};
	public labelView: string = '';

	constructor(private cb: ChangeDetectorRef) {}

	ngAfterViewInit(): void {
		this.config = {
			type: this.config.type || 'text',
			isMulti: this.config.type === 'icon' ? false : this.config?.isMulti || false,
			options: this.config.options || [],
		};
		this.setClassMode();

		this.config.options?.map((option) => {
			this.labels[option.value.toString()] = option.label;
		});

		this.cb.detectChanges();
	}
	ngOnChanges(changes: SimpleChanges): void {
		if (changes['value']) {
			if (this.value) {
				this.buildLabels();
				if (this.config.isMulti) {
					if (this.value.length === 0) {
						this.labelView = '';
					} else if (this.value.length === 1) {
						this.labelView = this.labels[this.value[0]].toString();
					} else {
						this.labelView = `${this.labels[this.value[0]].toString()} y ${this.value.length - 1} mas`;
					}
				} else {
					this.labelView = this.labels[this.value.toString()]?.toString() || '';
				}
			}
		}
		if (changes['config']) {
			this.buildLabels();
		}
	}

	buildLabels() {
		this.config.options?.map((option) => {
			this.labels[option.value.toString()] = option.label;
		});
	}

	setClassMode() {
		if (this.config.type !== 'text') {
			this.classMode = 'vlTk__control--selectIcon';
		} else if (this.config.isMulti) {
			this.classMode = 'vlTk__control--selectMulti';
		} else {
			this.classMode = 'vlTk__control--select';
		}
	}

	returnSelection(optionSelected: string | Array<string>) {
		let options: any = [optionSelected].flat(Infinity);

		if (this.config.isMulti) {
			if (optionSelected.length === 0) {
				this.labelView = '';
			} else if (optionSelected.length === 1) {
				this.labelView = this.labels[optionSelected[0]].toString();
			} else {
				this.labelView = `${this.labels[optionSelected[0]].toString()} y ${optionSelected.length - 1} mas`;
			}
		} else {
			this.labelView = this.labels[optionSelected[0]]?.toString() || '';
		}

		options.forEach((option: string) => {
			if (option === 'true') {
				return true;
			} else if (option === 'false') {
				return false;
			} else if (!isNaN(Number(option))) {
				return Number(option);
			} else {
				return option;
			}
		});

		this.value = this.config.isMulti ? options : options[0] || '';

		this.changeSelection.emit(this.value);
	}
}
